import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import Breadcrumb from '../common/breadcrumb';
import { generateEngagementReport as generateReportService } from '../../services/reports';
import { getTrailsForSelect } from '../../services/trails';

const Engajamento = () => {
  const [trails, setTrails] = useState([]);
  const [selectedTrails, setSelectedTrails] = useState([]);

  const [courseInitMin, setCourseInitMin] = useState('');
  const [courseInitMax, setCourseInitMax] = useState('');
  const [courseFinishMin, setCourseFinishMin] = useState('');
  const [courseFinishMax, setCourseFinishMax] = useState('');

  const generateReport = async format => {
    const queryStrings = {
      trail_id_ft: selectedTrails.map(trail => trail.value),
      start_at_gte: courseInitMin,
      start_at_lte: courseInitMax,
      finish_at_gte: courseFinishMin,
      finish_at_lte: courseFinishMax,
    };

    for (let prop of Object.keys(queryStrings)) {
      if (!queryStrings[prop]) {
        delete queryStrings[prop];
      }
    }

    await generateReportService(format, queryStrings);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    let localTrails = await getTrailsForSelect();
    setTrails(localTrails);
  };

  const dataAtual = `${`${new Date().getFullYear()}-${(
    new Date().getMonth() + 1
  )
    .toString()
    .padStart(2, '0')}-${new Date().getDate()}`}`;

  return (
    <>
      <Breadcrumb title="Relatórios - Engajamento" parent="Relatórios" />
      <div className="container-fluid">
        <div className="card">
          <div className="card-header">
            <h5>Engajamento</h5>
          </div>
          <div className="card-body">
            <form>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <div
                  style={{
                    width: '100%',
                  }}
                >
                  <label htmlFor="trilhas">Disciplinas</label>

                  <Select
                    id="trilhas"
                    styles={{
                      width: '100%',
                    }}
                    isMulti={true}
                    options={trails}
                    value={selectedTrails}
                    onChange={options => setSelectedTrails(options || [])}
                  />
                </div>
              </div>

              <div
                style={{
                  width: '100%',
                }}
                className="mb-2"
              >
                <label htmlFor="trilhas">
                  Data de Inicio do Curso (De - Até)
                </label>

                <div className="d-flex justify-content-between align-items-center">
                  <input
                    id="inicio"
                    type="date"
                    className="form-control"
                    style={{
                      width: '48%',
                    }}
                    value={courseInitMin}
                    onKeyDown={e => e.preventDefault()}
                    onChange={e => setCourseInitMin(e.target.value)}
                    max={courseInitMax || dataAtual}
                  />

                  <input
                    id="fim"
                    type="date"
                    className="form-control"
                    style={{
                      width: '48%',
                    }}
                    value={courseInitMax}
                    onKeyDown={e => e.preventDefault()}
                    onChange={e => setCourseInitMax(e.target.value)}
                    min={courseInitMin}
                    max={dataAtual}
                  />
                </div>
              </div>

              <div
                style={{
                  width: '100%',
                }}
              >
                <label htmlFor="trilhas">
                  Data de Finalização do Curso (De - Até)
                </label>

                <div className="d-flex justify-content-between align-items-center mb-2">
                  <input
                    id="inicio"
                    type="date"
                    className="form-control"
                    style={{
                      width: '48%',
                    }}
                    value={courseFinishMin}
                    onKeyDown={e => e.preventDefault()}
                    onChange={e => setCourseFinishMin(e.target.value)}
                    max={courseFinishMax || dataAtual}
                  />

                  <input
                    id="fim"
                    type="date"
                    className="form-control"
                    style={{
                      width: '48%',
                    }}
                    value={courseFinishMax}
                    onKeyDown={e => e.preventDefault()}
                    onChange={e => setCourseFinishMax(e.target.value)}
                    min={courseInitMin}
                    max={dataAtual}
                  />
                </div>
              </div>

              <div className="d-flex justify-content-center align-items-center my-3">
                <button
                  type="button"
                  className="btn btn-primary mr-2"
                  onClick={() => generateReport('pdf')}
                >
                  Gerar Relatório (PDF)
                </button>

                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => generateReport('csv')}
                >
                  Gerar Relatório (CSV)
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Engajamento;
